import React, { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import {
    FullImageContainer,
    MainContainer,
    MainTitle,
    SearchComponent,
    TitleContainer,
} from "@beacharound/beacharound-ui";

import {
    trackSearch,
} from "@beacharound/beacharound-ui-helpers";

import { getPlacesAll } from "../../api/search/places";
import { useGeolocalization } from "../../contexts/geolocalization";
import { getBeach } from "../../api/beach";
import { getHotel } from "../../api/hotels";
import { getPlace } from "../../api/places";
import { updateSearchTerms } from "../../api/search/terms";
import { getLocationsLean } from "../../api/search/locations";
import { getLocationsOptionsFromData } from "../../helpers/search";

export default function PlacesSearchHeader({
    history,
    title,
    cover,
    params,
    withBeaches,
    withHotels,
}) {

    const { hasGeolocalization, geoCoordinates } = useGeolocalization();
    const [ isLoadingSearch, setIsLoadingSearch ] = useState()

    let options = {
        // sort: {"highlight.fromDate": -1},
        params: {
            ...params,
            published: true,
        },
        withBeaches,
        withHotels,
    };

    if (
        hasGeolocalization &&
        geoCoordinates?.latitude &&
        geoCoordinates?.longitude
    ) {
        options = {
            ...options,
            latitude: geoCoordinates?.latitude,
            longitude: geoCoordinates?.longitude,
        }
    }
    

    const queryCache = useQueryClient();

    const { data: hotels } = useQuery(["places", options], () =>
        getPlacesAll({ params: options }),
        {
            refetchOnWindowFocus: false,
            enabled: !!withHotels,
        }
    )
    const { data: places } = useQuery(["places", options], () =>
        getLocationsLean({ params: options }),
        {
            refetchOnWindowFocus: false,
            enabled: !withHotels,
        }
    )

    const data = withHotels ? hotels : places;

    async function loadOptions(search, callback) {
        const searchOptions = {
            ...options,
            search,
        };

        const result = withHotels ?
            await getPlacesAll({ params: searchOptions })
        :
            await getLocationsLean({params: searchOptions});

        trackSearch({ search });

        queryCache.setQueryData(["places", searchOptions], result);

        return callback(
            getLocationsOptionsFromData(result, {
                withBeaches: withBeaches,
                withHotels: withHotels,
            })
        );
    }

    async function goToPage(name, value, field) {
        let path, prefetch;

        switch (field.type) {
            case "beaches":
                path = "/spiagge";
                prefetch = getBeach;
                break;
            case "hotels":
                path = "/hotel";
                prefetch = getHotel;
                break;
            default:
                path = "/luoghi";
                prefetch = getPlace;
                break;
        }

        if (field?.search && field?._id && field?.type) {
            updateSearchTerms({
                search: field?.search,
                selected: { _id: field?._id, type: field?.type },
            });
        }

        await queryCache.prefetchQuery([field.type, value], () =>
            prefetch({ slug: value })
        );

        setIsLoadingSearch()
        return history.push(`${path}/${value}`);
    }

    function searchOtherHandler(query) {
        updateSearchTerms({ search: query, noSelected: true });
        history.push(`/ricerca/spiagge?search=${query}`);
    }

    return (
        <FullImageContainer image={cover} overlay>
            <MainContainer>
                <TitleContainer>
                    <MainTitle
                        text={title}
                        color="white"
                        center
                        component="h1"
                    />
                </TitleContainer>
                <SearchComponent
                    isAsync
                    loadOptions={loadOptions}
                    defaultOptions={getLocationsOptionsFromData(data, {
                        withBeaches: withBeaches,
                        withHotels: withHotels,
                    })}
                    onChangeInput={goToPage}
                    nearAction={() => history.push(`/vicino-a-te`)}
                    buttonText="Dove vuoi prenotare?"
                    otherAction={searchOtherHandler}

                    isLoadingSearch={isLoadingSearch}
                    setIsLoadingSearch={setIsLoadingSearch}
                />
            </MainContainer>
        </FullImageContainer>
    );
}
